var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainMobileCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 165,
    viewBox: "0 0 70 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70Z",
    fill: "#173AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 130C54.33 130 70 121.046 70 110C70 98.9543 54.33 90 35 90C15.67 90 0 98.9543 0 110C0 121.046 15.67 130 35 130Z",
    fill: "#173AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 165C54.33 165 70 161.642 70 157.5C70 153.358 54.33 150 35 150C15.67 150 0 153.358 0 157.5C0 161.642 15.67 165 35 165Z",
    fill: "#173AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainMobileCircle);
export default __webpack_public_path__ + "static/media/main_mobile_circle.f720e60f6e4b112a9f5b5d2b5cd21929.svg";
export { ForwardRef as ReactComponent };